import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import Styles from '../Styles';

Meteor.publish('styles', function styles() {
  return Styles.find({ owner: this.userId }, { fields: { 'geojsonStyle.styleData.legend': 0 } });
});

// Note: styles.view is also used when editing an existing document.
Meteor.publish('styles.view', function stylesView(styleId) {
  check(styleId, String);
  return Styles.find({ _id: styleId, owner: this.userId });
});

Meteor.publish('styles.public', () => {
  return Styles.find(
    { deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});

Meteor.publish('styles.layers', function stylesLayers(styleIds) {
  return Styles.find({ owner: this.userId, _id: { $in: styleIds } });
});

Meteor.publish('styles.publicLayers', function stylesPublicLayers(styleIds) {
  return Styles.find(
    { _id: { $in: styleIds }, deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});
